import template from './swag-cms-extensions-custom-form-element-preview.html.twig';
import './swag-cms-extensions-custom-form-element-preview.scss';

export default {
    template,
}
